import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@storable/canaveral-components';
import FileList from 'containers/MediaLibrary/FileListContainer';
import NewFileForm from 'containers/MediaLibrary/NewFileFormContainer';
import EditFileForm from 'containers/MediaLibrary/EditFileFormContainer';
import { format } from '../../../../modules/slug';

const propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onAttach: PropTypes.func.isRequired,
};

const defaultProps = {};

class MediaLibrary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editingFile: null,
      uploadingFile: null,
    };

    this.id = 'media-library';
  }

  onUpload = uploadingFile => this.setState({
    uploadingFile,
  })

  onEdit = editingFile => this.setState({
    editingFile,
  })

  onAttach = (file) => {
    const { onAttach } = this.props;
    const { name, path } = file;

    onAttach({ text: name, href: path });
  }

  onReturn = () => this.setState({
    editingFile: null,
    uploadingFile: null,
  })

  render() {
    const { uploadingFile, editingFile } = this.state;
    const { onDismiss, show } = this.props;

    let content = (
      <React.Fragment>
        <Modal.Body>
          <FileList
            onEdit={this.onEdit}
            onAttach={this.onAttach}
            onUpload={this.onUpload}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            context="neutral"
            onClick={onDismiss}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </React.Fragment>
    );

    if (uploadingFile) {
      const parts = uploadingFile.name.split('.');

      const filename = parts.length === 1
        ? format(parts[0])
        : `${format(parts.slice(0, -1).join(''))}.${parts[parts.length - 1]}`;

      const name = parts.length === 1
        ? parts[0]
        : parts.slice(0, -1).join('.');

      content = (
        <NewFileForm
          name={name}
          filename={filename}
          file={uploadingFile}
          onReturn={this.onReturn}
        />
      );
    }

    if (editingFile) {
      content = (
        <EditFileForm
          id={editingFile.id}
          name={editingFile.name}
          onReturn={this.onReturn}
          filename={editingFile.filename}
        />
      );
    }

    return (
      <Modal
        size="lg"
        show={show}
        onDismiss={onDismiss}
        aria-labelledby={this.id}
      >
        <Modal.Header>
          <Modal.Title id={this.id}>
            Attach File
          </Modal.Title>
        </Modal.Header>
        {content}
      </Modal>
    );
  }
}

MediaLibrary.propTypes = propTypes;
MediaLibrary.defaultProps = defaultProps;

export default MediaLibrary;
